export enum InvestmentState {
  none = "none",
  created = "created",
  acceptedInvestorInformation = "acceptedInvestorInformation", // Effecta
  investorInformationEmailApproved = "investorInformationEmailApproved",
  approvedUpToDatenessOfPersonalData = "approvedUpToDatenessOfPersonalData", // Effecta
  signedVIB = "signedVIB", // Effecta Subordinated Loan
  submittedAmount = "submittedAmount", // Effecta Secured Loan
  contractDataApproved = "contractDataApproved",
  submittedInvestorSurvey = "submittedInvestorSurvey", // Effecta
  investorSurveyApproved = "investorSurveyApproved",
  submittedIdentificationPreInfos = "submittedIdentificationPreInfos", // Effecta
  validatedIdentity = "validatedIdentity", // Effecta
  confirmedBankAccount = "confirmedBankAccount", // Effecta Subordinated Loan
  confirmedDepot = "confirmedDepot", // Effecta Secured Loan
  acceptedCosts = "acceptedCosts", // Effecta
  submittedSigningDeclaration = "submittedSigningDeclaration", // Effecta
  submitted = "submitted",
  revocationFree = "revocationFree",
  paid = "paid",
  paidAndRevocationFree = "paidAndRevocationFree",
  inProgressByEffecta = "inProgressByEffecta", // Effecta
  acceptedByEffecta = "acceptedByEffecta", // Effecta
  declinedByEffecta = "declinedByEffecta", // Effecta
  inProgressByEmitter = "inProgressByEmitter", // Effecta
  acceptedByEmitter = "acceptedByEmitter", // Effecta
  declinedByEmitter = "declinedByEmitter", // Effecta
  active = "active",
  repaid = "repaid",
  cancelled = "cancelled",
  aborted = "aborted",
  insolvent = "insolvent"
}

export default InvestmentState;
